import { BASE_API_URL } from '../constants'
import Token from './Token'

export const UserSessionsApi = {
    get: (page, limit = 25) => {
        return fetch(
            BASE_API_URL +
                '/api/user/session-data?page=' +
                page +
                '&limit=' + limit +
                '&states=completed,cancelled,requested,rejected,active',
            {
                method: 'GET',
                headers: {
                    Authorization: 'Bearer ' + Token.getToken(),
                },
            }
        ).then((r) => {
            if (r.ok) {
                return r.json()
            }
            throw new Error(r.statusText)
        })
    },
}
